module.exports = __webpack_public_path__ + "img/invite-patients-button-ru.b3f97ee1.png";